module.exports = __webpack_public_path__ + "static/media/thermostat.465e82a8.jpg";